import { graphql } from 'gatsby';

export { default } from './HonorsAndAwards';

export const honorsAndAwardsQuery = graphql`
  query HonorsAndAwardsQuery {
    markdownRemark(
      fileAbsolutePath: { regex: "/about/honors-and-awards.md/" }
    ) {
      html
      frontmatter {
        content {
          text_md
          date
          subtext_md
        }
      }
    }
  }
`;
